const pad2 = (n: number): string => String(n).padStart(2, '0');

export const prettyHM = (date: Date | string): string => {
  const d = new Date(date);
  return `${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
};
